<template>
  <div class="pengumuman-container">
    <Forbidden
      v-if="
      getUserRole[getUserRole.length - 1].role_id == userRole.STUDENT || 
      getStudentTermStatus != termStatus.QUIT || 
      getEndedTermId != getTermName"
      routerPath="incorrectRole"
    />
    <section v-else class="vector-background col center">
      <b-button class="col-5 ml-3 primary" size="sm" @click="downloadReport">Download Report</b-button>
    </section>
  </div>
</template>

<script>
import Forbidden from "@/views/Forbidden";
import { mapGetters } from "vuex";
import User from "@/services/User";
import { UserRole, TermStatus } from "@/services/StatusCode";

export default {
  name: "DecisionForm",
  data() {
    return {
      report: "",
      userRole: UserRole,
      termStatus: TermStatus
    };
  },
  components: {
    Forbidden
  },
  methods: {
    downloadReport() {
      User.getDownloadReportLink(
        process.env.VUE_APP_URL,
        this.getAccessToken,
        this.getFullname
      );
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUserId: "getUserId",
      getUserRole: "getUserRole",
      getTermName: "getTermName",
      getRegistrationData: "getRegistrationData",
      getFullname: "getFullname",
      getStudentTermStatus: "getStudentTermStatus",
      getEndedTermId: "getEndedTermId"
    })
  }
};
</script>


<style lang="scss" scoped>
@import "@/styles/form.scss";

@media only screen and (min-width: 768px) {
  h1.header-title {
    font-size: $h1 !important;
  }

  h2.header-title {
    font-size: $h2 !important;
  }

  h3.header-title {
    font-size: $h3 !important;
  }

  .hero-message {
    margin-bottom: 5%;
    max-width: 50%;
  }
  .message {
    max-width: 100% !important;
    font-size: 16px !important;
  }
}

.pengumuman-container {
  min-height: inherit;
}

.rejected {
  color: red;
}

.hero-message {
  max-width: 75%;
  margin-bottom: $gap-m-2;
}

.message {
  margin-top: $gap-sm-1;
  text-align: center;
  max-width: 80%;
  font-size: 12px;
}

.message-container {
  min-width: 20%;
  max-height: 40%;
  margin-bottom: $gap-m-2;
}

.header-title {
  margin-bottom: $gap-m-1;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}

.nominal-container {
  text-align: center;
  .nominal {
    font-size: 24px;
  }
}
.pembayaran-container {
  .salin-jumlah {
    color: $primary;
  }
}

.success-payment-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rekening-container {
  display: flex;
  align-items: center;
  margin: $gap-sm-2 0;

  .rekening {
    padding: $gap-sm-1 $gap-sm-2;
    background: $white;
    margin-right: $gap-sm-2;
  }
}

#submit {
  display: flex;
  align-items: center;

  .material-icons {
    color: white;
    margin-left: $gap-sm-1;
  }
}

.upload-container {
  margin-top: $gap-sm-2;
}

.red {
  color: #eb4d55;
}

.black {
  color: #000000;
}

.svg-4 {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: -1;
  max-width: 40%;
  max-height: 20%;
}

.svg-5 {
  position: absolute;
  z-index: -2;
  bottom: 0;
  left: 0;
  max-width: 40%;
  max-height: 25%;
}

.svg-6 {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: -1;
  max-width: 40%;
  max-height: 50%;
}

.svg-7 {
  position: absolute;
  z-index: -2;
  bottom: 0;
  right: 0;
  max-width: 30%;
  max-height: 50%;
}
</style>

